import { audio } from "@/lib/sounds";

// Generated lullaby (no audio files): soft pentatonic music-box arpeggio over a slow warm pad.
const MELODY = [523.25, 659.25, 783.99, 659.25, 880, 783.99, 659.25, 587.33, 523.25, 659.25, 783.99, 1046.5, 880, 783.99, 659.25, 587.33];
const PAD = [[130.81, 196], [174.61, 261.63], [146.83, 220], [130.81, 196]];
const STEP = 0.72;
let state = null;

const note = (ac, out, freq, at) => {
  const o = ac.createOscillator();
  const g = ac.createGain();
  o.type = "sine";
  o.frequency.value = freq;
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(0.9, at + 0.03);
  g.gain.exponentialRampToValueAtTime(0.001, at + 1.8);
  o.connect(g).connect(out);
  o.start(at); o.stop(at + 1.9);
};

const pad = (ac, out, [a, b], at, dur) => {
  [a, b, a * 1.005].forEach((f) => {
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.type = "triangle";
    o.frequency.value = f;
    g.gain.setValueAtTime(0, at);
    g.gain.linearRampToValueAtTime(0.25, at + dur * 0.4);
    g.gain.linearRampToValueAtTime(0, at + dur);
    o.connect(g).connect(out);
    o.start(at); o.stop(at + dur + 0.1);
  });
};

export const startLullaby = () => {
  if (state) return true;
  const ac = audio();
  if (!ac) return false;
  const master = ac.createGain();
  master.gain.setValueAtTime(0, ac.currentTime);
  master.gain.linearRampToValueAtTime(0.07, ac.currentTime + 2.5);
  master.connect(ac.destination);
  state = { ac, master, next: ac.currentTime + 0.1, i: 0 };
  const tick = () => {
    if (!state) return;
    while (state.next < ac.currentTime + 1.2) {
      if (state.i % MELODY.length === 0) pad(ac, master, PAD[(state.i / MELODY.length) % PAD.length], state.next, STEP * MELODY.length);
      note(ac, master, MELODY[state.i % MELODY.length], state.next);
      state.next += STEP;
      state.i += 1;
    }
  };
  tick();
  state.timer = setInterval(tick, 250);
  return true;
};

export const stopLullaby = () => {
  if (!state) return;
  const { ac, master, timer } = state;
  clearInterval(timer);
  state = null;
  master.gain.cancelScheduledValues(ac.currentTime);
  master.gain.setValueAtTime(master.gain.value, ac.currentTime);
  master.gain.linearRampToValueAtTime(0, ac.currentTime + 1.5);
  setTimeout(() => master.disconnect(), 1700);
};

export const isLullabyPlaying = () => !!state;
